<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card text-white bg-primary">
    <div class="d-flex flex-column justify-content-between h-100">
      <div class="d-flex justify-content-between">
        <!--Name and ID-->
        <div class="card-id text-left">
          <p class="mb-1 font-size-14 font-weight-bold card-name w-80" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </p>
          <div class="d-flex font-size-12">
            <div>{{ memberCard.ProductCode }}</div>
            <div class="px-1">-</div>
            <div>{{ memberCard.MemberId }}</div>
          </div>
        </div>
        <!--Logo-->
        <img alt="" class="card-logo" src="assets/images/logo.svg" draggable="false" />
      </div>

      <hr class="bg-white" />
      <!--Balances-->
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-end mb-1">
          <div class="card-account-no text-left border-right border-white pr-3" *ngIf="pointsBalance$">
            <label class="mb-1">{{ 'member.card.points.balance' | translate }}</label>
            <div class="font-size-14">{{ pointsBalance$ | async }}</div>
          </div>
          <!-- <div class="balance-splitter mx-3">|</div> -->
          <div class="card-id text-left pl-3" *ngIf="ecash$">
            <label class="mb-1">{{ 'member.card.ecash.balance' | translate }}</label>
            <div class="font-size-14">{{ ecash$ | async | FortressCurrencyPipe }}</div>
          </div>
        </div>
        <div class="d-block d-lg-none">
          <div class="barcode d-lg-none d-block">
            <button
              type="button"
              class="btn btn-white wallet-button text-primary border-0 p-0 d-flex justify-content-center align-items-center"
              [routerLink]="['/rewards/wallet']"
            >
              <span class="icon icon-qr-code font-weight-bold"></span>
              <span class="ml-1 font-weight-bold font-size-14">Show Card</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
